module.exports = __webpack_public_path__ + "img/redheads.f7bd556f.png";